<script setup lang="ts">
  import {Model} from "@/app/Model";
  import {FiltriReatoRubrica, PenaleAdmin} from "@/app/data/PenaleAdmin";

  let model: Model = Model.getReactiveInstance();
  const emit = defineEmits(["recalc"]);

  function handleSubmit(): void {
    //resetto per evitare di portarmi dietro l'offset se sono andato avanti con la paginazione
    model.pen_admin.paginazioneReatoRubrica_start = 0;

    emit("recalc");
  }
  function resetFiltri(): void {
    model.pen_admin.filtriReatoRubrica = new FiltriReatoRubrica();
    handleSubmit();
  }
</script>

<template>
<div class="admin-filtri mb-2 row">
  <div class="col-4 mb-2">
    <label for="filtri_capo_imputazione_str">Capo Imputazione</label>
    <input type="text" class="form-control" id="filtri_capo_imputazione_str" v-model.number="model.pen_admin.filtriReatoRubrica.capo_imputazione_str">
  </div>
  <div class="col-4 mb-2">
    <label for="filtri_tip_atto">Tipo atto</label>
    <input type="text" class="form-control" id="filtri_tip_atto" v-model="model.pen_admin.filtriReatoRubrica.tip_atto">
  </div>
  <div class="col-4 mb-2">
    <label for="filtri_rubrica">Rubrica</label>
    <input type="text" class="form-control" id="filtri_rubrica" v-model="model.pen_admin.filtriReatoRubrica.rubrica">
  </div>
 
  <div class="col-4 mb-2">
    <label for="filtri_sortField">Ordinamento: Campo</label>
    <select class="form-select" id="filtri_sortField" v-model="model.pen_admin.filtriReatoRubrica.sort_field">
      <option value="capo_imputazione_str">capo_imputazione_str</option>
      <option value="tip_atto">tip_atto</option>
      <option value="rubrica">rubrica</option>
    </select>
  </div>
  <div class="col-4 mb-2">
    <label for="filtri_sortOrder">Ordinamento: Direzione</label>
    <select class="form-select" id="filtri_sortOrder" v-model="model.pen_admin.filtriReatoRubrica.sort_order">
      <option value="DESC">DESC</option>
      <option value="ASC">ASC</option>
    </select>
  </div>
  <div class="col-4 mb-2">
    <div>&nbsp;</div>
    <button type="button" class="btn btn-primary me-1" @click="handleSubmit()">Filtra</button>
    <button type="button" class="btn btn-sm btn-secondary" @click="resetFiltri()">Reset</button>
  </div>
</div>
</template>